
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/shipping-and-delivery",
      function () {
        return require("private-next-pages/info/shipping-and-delivery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/shipping-and-delivery"])
      });
    }
  